module.exports = __webpack_public_path__ + "static/media/hero_desktop.208929cd.webp";